import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'synfrastructure';
import { createSession } from './redux/actions';
import { pushToast } from '../../../redux/actions';
import cloneDeep from 'lodash/cloneDeep';
import Icon from '../../../common/icons/Icon';
import moment from 'moment-timezone';
import SessionRequestModal from '../../../common/components/session-requests/SessionRequestModal';
import getDecodedToken from '../../../common/auth/utils/getDecodedToken';
import { reportTrainingPurchase, sendIntercomEvent } from '../../../common/events';
import numeral from 'numeral';

class MovementSpecialistProfile extends Component {
  static propTypes = {
    goBack: PropTypes.func,
    movementSpecialist: PropTypes.object,
    mobileView: PropTypes.string,
  };

  state = {
    modalVisible: false,
  };

  componentDidMount = () => {
    const { movementSpecialist } = this.props;
    movementSpecialist && sendIntercomEvent('viewed_ms', { id: movementSpecialist.id, name: movementSpecialist.name });
  };

  handleToggleModal = () => {
    !this.state.modalVisible && sendIntercomEvent('viewed_movement_specialist_purchase_modal');
    this.setState(state => {
      return {
        modalVisible: !state.modalVisible,
      };
    });
  };

  handleSubmit = values => {
    const { dispatch, movementSpecialist } = this.props;
    const submitValues = cloneDeep(values);

    submitValues.requestedDates = submitValues.requestedDates.map(obj => {
      let hour = parseInt(obj.time.substr(0, 2), 10);

      if (obj.time.substr(0, 2) === '12') {
        hour = 0;
      }

      if (obj.time.substr(5, 2) === 'PM') {
        hour += 12;
      }

      return moment(obj.date)
        .tz(movementSpecialist.time_zone_id)
        .hour(hour)
        .minute(parseInt(obj.time.substr(3, 2), 10))
        .format();
    });

    submitValues.movementSpecialistId = movementSpecialist.user_id;

    return dispatch(createSession(getDecodedToken().sub, submitValues)).then(action => {
      if (!action.response.ok) {
        this.props.dispatch(
          pushToast({
            message: 'There was a problem while submitting your request.',
            status: 'error',
          })
        );
      } else {
        reportTrainingPurchase({
          gaEventLabel: 'Movement Specialist',
          intercomEventName: 'member_request',
          intercomEventData: {
            ms: {
              id: movementSpecialist.id,
              name: movementSpecialist.name,
            },
            dates: submitValues.requestedDates,
            message: submitValues.message,
          },
        });
      }
    });
  };

  render() {
    const { goBack, movementSpecialist, isMobile, mobileView, session } = this.props;
    const { modalVisible } = this.state;

    console.log('movementSpeicalist', movementSpecialist)

    let price = numeral(movementSpecialist.price / 100).format('$0,0');

    let backText = isMobile && mobileView === 'list' ? 'List' : 'Map';

    return (
      <div className="ms__profile">
        {modalVisible ? (
          <Modal isVisible onClose={this.handleToggleModal}>
            <SessionRequestModal
              availability={movementSpecialist.availability}
              imageLocation={movementSpecialist.profileImage.location}
              name={movementSpecialist.name}
              onCancel={this.handleToggleModal}
              onSubmit={this.handleSubmit}
              session={session}
              price={movementSpecialist.price}
              timeZoneId={movementSpecialist.time_zone_id}
              type="movement-specialist"
            />
          </Modal>
        ) : null}
        {movementSpecialist.header_image_id ? (
          <div
            className="ms__header-img"
            style={{ backgroundImage: `url(${movementSpecialist.headerImage.location})` }}
          />
        ) : (
          <div
            className="ms__header-img"
            style={{ backgroundImage: `url(https://d27vybgvtr1dba.cloudfront.net/ms-header.jpg)` }}
          />
        )}
        {goBack ? (
          <div onClick={goBack} className="ms__profile-back">
            <span className="button__back-button">
              <Icon icon="BackArrow" />Back to {backText}
            </span>
          </div>
        ) : null}
        <div className="ms__profile__content__wrapper">
          <div
            className="ms__profile-img"
            style={{ backgroundImage: `url(${movementSpecialist.profileImage.location})` }}
          />
          <div className="ms__profile__content">
            <div className="ms__profile__info">
              <div className="ms__info-item">
                <h4>Member Since</h4>
                <p>{moment(movementSpecialist.user.created_at).format('MMMM Y')}</p>
              </div>
              <div className="ms__info-item">
                <h4>Location</h4>
                <p>{movementSpecialist.location_short}</p>
              </div>
              <div className="ms__info-item">
                <h4>Availability</h4>
                <p>{movementSpecialist.availability}</p>
              </div>
            </div>
            <div className="ms__profile__bio">
              <div className="ms__profile__bio-container">
                <div className="ms__profile__bio-request">
                  <div>
                    <h3>{movementSpecialist.name}</h3>
                    <h5>Certified Movement Specialist</h5>
                  </div>
                  {movementSpecialist.user.id !== getDecodedToken().sub && (
                    <button type="button" className="button button--price" onClick={this.handleToggleModal}>
                      <span>Request Follow-Up</span>
                      <i>{price}</i>
                    </button>
                  )}
                </div>
              </div>
              <div className="ms__profile__bio-container">
                <h4>Biography</h4>
                <p className="long-description">{movementSpecialist.biography}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    isMobile: state.browser.lessThan.desktop,
    session: state.subscription.movementSpecialists.session,
  };
};

export default connect(mapStateToProps)(MovementSpecialistProfile);



// WEBPACK FOOTER //
// ./src/subscription/coaching/movement-specialists/MovementSpecialistProfile.js